import React from 'react'
import moment from 'moment'

const Footer = () => {
  return (
<footer className="text-gray-400 body-font bg-gray-900">
  <div className="container px-5 py-4 mx-auto flex items-center sm:flex-row flex-col">
    <a href="/" className="flex title-font font-medium items-center md:justify-start justify-center text-gray-200">

      <span className="ml-3 text-xl">Thought Space</span>
    </a>
    <p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">© {moment().format("YYYY")} Thought Space —
    </p>
    <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">

      <a href="https://victor-nyangi-personal-portfolio.vercel.app/" target="_blank" rel="noopener noreferrer" title="My Portfolio" className="ml-3 text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
  <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
</svg>
      </a>
      <a href="https://github.com/Victor-Nyangi" target="_blank" rel="noopener noreferrer" title="Github" className="ml-3 text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
  <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
</svg>
      </a>
      <a href="https://www.linkedin.com/in/victor-nyangi-6b0805181" target="_blank" rel="noopener noreferrer" title="LinkedIn" className="ml-3 text-gray-500">
        <svg fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={0} className="w-5 h-5" viewBox="0 0 24 24">
          <path stroke="none" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
          <circle cx={4} cy={4} r={2} stroke="none" />
        </svg>
      </a>
    </span>
  </div>


</footer>

  )
}

export default Footer